var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusPaidPendingCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000006257"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 77",
    d: "M6 12C7.05266 12 8.08679 11.7231 8.99857 11.197C9.91034 10.6709 10.6677 9.9142 11.1945 9.00286C11.7213 8.09153 11.9991 7.05762 12 6.00496C12.0009 4.9523 11.7248 3.91794 11.1995 3.00573L6 6L6 12Z",
    fill: "#FFE296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 78",
    d: "M0.771178 3.05731C0.254903 3.97467 -0.0109388 5.01172 0.000344705 6.06431C0.0116282 7.11691 0.29964 8.14802 0.835461 9.0541C1.37128 9.96019 2.13605 10.7094 3.05299 11.2264C3.96992 11.7434 5.00675 12.0101 6.05935 11.9997L6 6L0.771178 3.05731Z",
    fill: "#D81717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPaidPendingCancel);
export default __webpack_public_path__ + "static/media/status-paid-pending-cancel.1fbd67896d77e5a09e3c56cf6dd7dd37.svg";
export { ForwardRef as ReactComponent };